var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8678 2.58405L18.9144 14.9164C19.7333 16.3498 18.6982 18.1338 17.0477 18.1338H2.95439C1.30291 18.1338 0.267856 16.3498 1.08762 14.9164L8.13426 2.58405C8.95954 1.13865 11.0425 1.13865 11.8678 2.58405Z",
    fill: "url(#paint0_linear_24559_70373)",
    stroke: "url(#paint1_linear_24559_70373)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 14.6286C9.10217 14.1351 9.50212 13.7354 9.99554 13.735C10.4888 13.7356 10.8885 14.1353 10.8891 14.6286C10.8885 15.1219 10.4889 15.5217 9.99554 15.5225C9.50206 15.5219 9.10217 15.122 9.10156 14.6286ZM9.1703 7.86815C9.1703 7.38698 9.52545 7.08911 9.99517 7.08911C10.4538 7.08911 10.8204 7.39844 10.8204 7.86815V12.28C10.8204 12.7497 10.4538 13.059 9.99517 13.059C9.52545 13.059 9.1703 12.7608 9.1703 12.28V7.86815Z",
    fill: "#515151"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24559_70373",
    x1: 5,
    y1: 8,
    x2: 13,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_24559_70373",
    x1: 5,
    y1: 8,
    x2: 13,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F0A"
  })))));
};
export { SvgWarning as ReactComponent };
export default __webpack_public_path__ + "warning.svg";